import _ from "lodash";

export const getWantAdDetailMeta = (adDetails, tenant) => {
  const isBLSTenant = !!tenant?.id && tenant.id !== "default";
  const mlsName = isBLSTenant
    ? (tenant?.head?.title || "").replace(/ - Buyer Listing Service$/i, "") ||
      "MLS"
    : "";

  const blsReference = _.get(adDetails, "blsReference", null);

  const postedDate =
    _.get(adDetails, "publishedOn", null) ||
    _.get(adDetails, "createdOn", null);
  const parsedPostedDate = postedDate ? new Date(postedDate) : null;
  const postedLabel =
    parsedPostedDate && !isNaN(parsedPostedDate.getTime())
      ? parsedPostedDate.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : "";

  return {
    mlsName,
    blsReference,
    postedLabel,
    hasDetailMetaInfo: !!(mlsName || blsReference || postedLabel),
  };
};

// Cards keep "Agent @ brokerage" on the default tenant; on a BLS tenant they
// swap it for "{MLS} #BLS{ref} • Posted {date}", degrading per-field like the
// detail-page meta row so a pre-backfill listing (no blsReference) still
// shows a posted date instead of hiding the line entirely.
export const getAgentProfileCardBLSInfo = (adDetails, tenant) => {
  const { mlsName, blsReference, postedLabel } = getWantAdDetailMeta(
    adDetails,
    tenant,
  );

  // mlsName is only ever non-empty on a BLS tenant (see getWantAdDetailMeta),
  // so this alone is the tenant gate - no need to recompute isBLSTenant here.
  const showBLSInfo = !!mlsName && !!(blsReference || postedLabel);
  const blsInfoLine = showBLSInfo
    ? `${mlsName}${blsReference ? ` #BLS${blsReference}` : ""}${
        postedLabel ? ` • Posted ${postedLabel}` : ""
      }`
    : "";

  return { showBLSInfo, blsInfoLine };
};
